import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define modal state interface - removed callback
export interface ModalState {
  modalOpen: boolean;
  modalView: string | null;
  properties: any;
  lastResult?: any; // Store the last result instead of callback
}

export const modalViewsConst = {
  PointMapForm: "pointMapForm",
  addAssetForm: "addAssetForm",
  editAssetForm: "editAssetForm",
  uploadAssetForm: "uploadForm",
  brandNewModals: "brandNewModals",
  addAssetGroup: "addAssetGroup",
  addAssetNEW: "addAssetNEW",
  assetCallback: "assetCallback",
  windCurveCallback: "windCurveCallback", // Added new modal constant for wind curve callback
  deleteAsset: "deleteAsset",
  deleteAssetModal: "deleteAssetModal",
  deleteAssetGroup: "deleteAssetGroup",
  deletePerformanceCurve: "deletePerformanceCurve",
  deleteSolarEnergyModel: "deleteSolarEnergyModel",
  editAssetGroup: "editAssetGroup",
  editAssetNEW: "editAssetNEW",
  addPerformanceCurve: "addPerformanceCurve",
  editPerformanceCurve: "editPerformanceCurve",
  powerCurveGraph: "powerCurveGraph",
  solarEnergyModelPreview: "solarEnergyModelPreview",
  assetPowerCurveEdit: "assetPowerCurveEdit",
  customForecastEdit: "customForecastEdit",
  notification: "notification",
  passwordChange: "passwordChange",
  newSolarPowerCurve: "newSolarPowerCurve",
  energyModelSelect: "energyModelSelect",
  processedModelDownload: "processedModelDownload",
  changeProfilePicture: "changeProfilePicture",
  llmSetupAssets: "llmSetupAssets",
  platformConsent: "platformConsent",
  assetImageUpload: "assetImageUpload",
  assetGroupImageUpload: "assetGroupImageUpload",
  profileImageUpload: "profileImageUpload",
  organizationImageUpload: "organizationImageUpload",
  newProcessedModelSchema: "newProcessedModelSchema",
  deletePersona: "deletePersona",
  newHistoricalDataset: "newHistoricalDataset",
  uploadDatasetData: "uploadDatasetData",
  uploadForecast: "uploadForecast",
  viewPersonaDetails: "viewPersonaDetails",
  personaReady: "personaReady",
  manageSchedules: "manageSchedules",
  createSchedule: "createSchedule",
  generalDelete: "generalDelete",
  editSchedule: "editSchedule",
  v1EmailSchedule: "v1EmailSchedule",
  watershedAssign: "watershedAssign",
  hatUnlock: "hatUnlock",
  hatUnlockDone: "hatUnlockDone",
  checklistHints: "checklistHints",
  checklist: "checklist",
  modelGarden: "modelGarden",
  personaNudge: "personaNudge",
  chatMapDraw: "chatMapDraw",
  createComposedForecast: "createComposedForecast",
  editComposedForecast: "editComposedForecast",
  deleteComposedForecast: "deleteComposedForecast",
  copyComposedForecast: "copyComposedForecast",
  composedForecastDetail: "composedForecastDetail",
  processedModelFiles: "processedModelFiles",
  confirmDeleteFile: "confirmDeleteFile",
  addProject: "addProject",
  viewProjectTasks: "viewProjectTasks",
  projectImageUpload: "projectImageUpload",
  projectChat: "projectChat",
  datasetGraph: "datasetGraph",
  modelOutputDetail: "modelOutputDetail",
  historicalModel: "historicalModel",
  editDataset: "editDataset",
  confirmAddAssetFromMap: "confirmAddAssetFromMap",
  provideFeedback: "provideFeedback",
  welcomeTour: "welcomeTour",
  shareEmbed: "shareEmbed",
  manageSharedLinks: "manageSharedLinks",
  noSubscription: "noSubscription",
  adminCreateOrganization: "adminCreateOrganization",
  adminManageOrganizations: "adminManageOrganizations",
  adminAccessCodes: "adminAccessCodes",
  adminEnvVars: "adminEnvVars",
  adminGraphPreviewer: "adminGraphPreviewer",
  assetLimitReached: "assetLimitReached",
  modelLimitReached: "modelLimitReached",
  lightbox: "lightbox",
};

const initialState: ModalState = {
  modalOpen: false,
  modalView: null,
  properties: null,
  lastResult: undefined,
};

const ModalStateSlice = createSlice({
  name: "modalState",
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.modalOpen = action.payload;
      
      // If closing modal, clear the view as well if (!action.payload) { state.modalView = null; }
    },
    
    setModalStateProps: (state, action: PayloadAction<any>) => {
      state.properties = action.payload;
    },
    
    // Action to set modal state without callback
    setModalState: (state, action: PayloadAction<{
      modalOpen: boolean;
      modalView: string | null;
      properties?: any;
    }>) => {
      state.modalOpen = action.payload.modalOpen;
      state.modalView = action.payload.modalView;
      state.properties = action.payload.properties || null;
    },
    
    // Action to close modal with result
    closeModalWithResult: (state, action: PayloadAction<any>) => {
      // Store the result
      state.lastResult = action.payload;

      // Close the modal
      state.modalOpen = false;
      // state.modalView = null;
    },

    clearLastResult: (state) => {
      state.lastResult = undefined;
    },
  },
});

export const { setModalOpen, setModalStateProps, setModalState, closeModalWithResult, clearLastResult } =
  ModalStateSlice.actions;
export default ModalStateSlice.reducer;
